import React from "react";

export function GrowChat() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
      <path d="M38 7H10C5.58887 7 2 10.5889 2 15V29C2 33.4111 5.58887 37 10 37H13.5146C14.5835 37 15.5879 37.416 16.3433 38.1719L22.5859 44.4141C22.9766 44.8047 23.4883 45 24 45C24.5117 45 25.0234 44.8047 25.4141 44.4141L31.6562 38.1719C32.4121 37.416 33.417 37 34.4854 37H38C42.4111 37 46 33.4111 46 29V15C46 10.5889 42.4111 7 38 7Z" fill="#FFC107" />
      <path d="M35 26C35 27.1045 34.1045 28 33 28H15C13.8955 28 13 27.1045 13 26C13 24.8955 13.8955 24 15 24H33C34.1045 24 35 24.8955 35 26ZM35 16H13C11.8955 16 11 16.8955 11 18C11 19.1045 11.8955 20 13 20H35C36.1045 20 37 19.1045 37 18C37 16.8955 36.1045 16 35 16Z" fill="white" />
    </svg>
  );
}
